export default __webpack_public_path__ + "static/media/0d228108e9ba7f1dc81359a28d661289.jpg";